export default __webpack_public_path__ + "static/media/Image40.11184983.png";